// extracted by mini-css-extract-plugin
export default {"carouselNavigation":"rules_carousel_toolbar-module___carouselNavigation___f1f75c38","title":"rules_carousel_toolbar-module___title___efcd4377"};